// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "1.5.24/static/js/" + chunkId + "." + {"852":"3da7c420","863":"ce503df6"}[chunkId] + ".chunk.js";
};